<template>

    <div class="cc-app">
        <ccAlert v-if="settingsError" class="ma-4" :message="settingsError" type="error" />

        <div class="cc-card" v-else-if="isLoading || !age_tables">

			<div class="cc-loading"></div>

		</div>
        
        <div class="cc-persons" v-if="!isLoading && age_tables && age_tables.length > 0">
            <span v-for="(age_table, index) in age_tables" :key="age_table.id">
                
                <div class="cc-person px-4">
            
                    <div class="cc-person__information">
                        
                        <span>{{ age_table.name }}</span><br>

                        <span class="cc-person__ages" v-if="age_table.age_from && !age_table.age_to">{{ $t('From', {age: age_table.age_from}) }} </span> 
                        
                        <span class="cc-person__ages" v-if="age_table.age_to && !age_table.age_from">{{ $t('Till', {age: age_table.age_to}) }}</span> 
                        <span class="cc-person__ages" v-else-if="age_table.age_to">{{ $t('From Till', {age_1: age_table.age_from, age_2: age_table.age_to}) }}</span> 

                        <span class="cc-person__ages" v-if="age_table.months">({{ $t('Months') }})</span>

                    </div>

                    <div class="cc-person__selection">

                        <div class="cc-button-icon" @click="removePerson(index)">
                            <ccIcon name="minus"></ccIcon>
                        </div>

                        <input
                            type="text"
                            name="amount"
                            v-model.number="age_table.count"
                            @change="validatePerson(index, age_table.count)"
                            class="cc-person-input mx-2"
                        />

                        <div class="cc-button-icon" @click="addPerson(index)">
                            <ccIcon name="plus"></ccIcon>
                        </div>

                    </div>

                </div>

                <div class="cc-divider" v-if="index < (age_tables.length - 1)"></div>

            </span>

        </div>

        <div class="cc-persons pa-4" v-else>{{ $t("No age tables found") }}</div>
        
    </div>
 
</template>

<script>

import { mapGetters, mapState } from "vuex";
import { i18n } from "../../plugins/i18n"
import store from "../../store";

import ccIcon from "../../components/ccIcons";
import ccAlert from "../ccAlert";

export default {
    store,
    i18n,
    
    name: "ccPersons",

    // model: {
    //     prop: 'persons',
    //     event: 'personsUpdated'
    // },

    components: {
        ccIcon,
        ccAlert
    },

    watch: {
        age_tables: {
            deep: true,
            handler: () => {
                if(store.state.accommodation.accommodation && "id" in store.state.accommodation.accommodation){
                    store.dispatch("priceCalculation/get")
                }
            }
        }
    },

    computed: {
        ...mapState({
            isLoading: "administration/isLoading"
        }),
        
        ...mapGetters({
            settings: "app/settings",
            settingsError: "app/error",
        }),

        age_tables(){
            return store.getters["priceCalculation/getAgeTables"];
        },

        personsTotal(){
            return this.age_tables.reduce((accumulator, table) => {
                return accumulator + table.count
            },0)
        },

        birth_tables(){

            if(this.settings.birth_tables){
                return this.settings.birth_tables ;
            }

            return null ;
        },        
    },

    methods: {
        addPerson(index) {
            const accommodation = store.state.accommodation.accommodation;
            let updateTables = true;

            if(accommodation && "id" in accommodation){
                if(this.personsTotal + 1 > accommodation.meta.persons_max) updateTables = false;
            }

            if(updateTables){
                this.age_tables[index].count += 1;
                store.commit("priceCalculation/set_age_tables", this.age_tables)
            }
        },

        removePerson(index) {

            if(this.age_tables[index].count - 1 >= 0){
                this.age_tables[index].count -= 1
                store.commit("priceCalculation/set_age_tables", this.age_tables)
            }
        },

        validatePerson(index, amount) {
            let amountIsNotValid = false;
            const accommodation = store.state.accommodation.accommodation;

            if(accommodation && "id" in accommodation){
                if(this.personsTotal + amount > accommodation.meta.persons_max) amountIsNotValid = true;
            }

            if(isNaN(amount) || amount < 0){
                amountIsNotValid = true;
            }

            if(amountIsNotValid){
                this.age_tables[index].count = 0;
            } 
            else{
                store.commit("priceCalculation/set_age_tables", this.age_tables)
            }
        },
    },
}
</script>


<style lang="scss">
    @import "../../assets/scss/main"
</style>